import { EntityDropdownProps } from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import { DropdownInput } from "@validereinc/common-components";
import { EquipmentTypeType } from "@validereinc/domain";
import { Facilities } from "@validereinc/domain-controllers";
import React from "react";

const { FacilityStatusOptions } = Facilities.view;

export const FacilityStatusDropdownInput = ({
  name = "status",
  label,
  ...props
}: EntityDropdownProps<EquipmentTypeType>) => {
  return (
    <DropdownInput
      label={label ?? "Status"}
      name={name}
      options={FacilityStatusOptions}
      labelKey="label"
      valueKey="value"
      {...props}
    />
  );
};
